/**
 * Согласование существительного с числом по-русски.
 *
 * Мелочь, которая сразу читается как небрежность: «1 участников», «994 баллов»,
 * «1 слайдов». В интерфейсе, где числа меняются каждую секунду, это видно
 * постоянно, поэтому склейка числа со словом идёт только через эти функции.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  const n = Math.abs(count) % 100
  const last = n % 10

  if (n > 10 && n < 20) return many
  if (last > 1 && last < 5) return few
  if (last === 1) return one
  return many
}

/** Число вместе со словом: 1 участник, 2 участника, 5 участников. */
export function counted(count: number, one: string, few: string, many: string): string {
  return `${count} ${plural(count, one, few, many)}`
}

export const people = (n: number) => counted(n, 'участник', 'участника', 'участников')
export const points = (n: number) => counted(n, 'балл', 'балла', 'баллов')
export const slides = (n: number) => counted(n, 'слайд', 'слайда', 'слайдов')
export const answers = (n: number) => counted(n, 'ответ', 'ответа', 'ответов')
export const demos = (n: number) => counted(n, 'демонстрация', 'демонстрации', 'демонстраций')

/** Дата-время для списков: «29 окт, 14:05». ISO-строки с сервера — всегда UTC. */
export const when = (iso: string) =>
  new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(
    new Date(iso),
  )
